<template>
  <Content>
    <div class="md-layout md-gutter">
      <div class="div-btn-download">
        <md-button
          class="md-icon-button"
          @click="getXMLAll()">
          <md-icon>cloud_download
          </md-icon>
        </md-button>
        <md-tooltip md-direction="bottom">Baixar documentos filtrados</md-tooltip>
      </div>
      <div>
        <button
          type="button"
          class="md-button md-icon-button md-theme-default"
          @click="setDefault(0)">
          <div class="md-ripple">
            <div class="md-button-content">
              <i class="md-icon md-icon-font md-theme-default">rotate_left
              </i>
            </div>
          </div>
          <md-tooltip md-direction="bottom">Limpar filtros</md-tooltip>
        </button>
      </div>

      <div
        class="md-layout-item md-size-40"
        style="margin-top: 25px; margin-left: 5px;">
        <date-picker
          v-model="dateEmissionFrom"
          lang="pt-br"
          format="DD/MM/YYYY"
          width="150"
          placeholder="De"/>
        <date-picker
          v-model="dateEmissionTo"
          lang="pt-br"
          format="DD/MM/YYYY"
          width="150"
          placeholder="Até"
          @input="setItens(1)"/>
        <md-tooltip md-direction="bottom">
          Após informar os dois campos, o filtro será feito
        </md-tooltip>
      </div>
      <div class="md-layout-item md-size-15 filter-model">
        <md-field>
          <md-select
            id="model"
            v-model="model"
            name="model"
            placeholder="Modelo Eletrônico"
            @input="setItens(2)">
            <md-option value="55">Nota Fiscal Eletrônica</md-option>
            <md-option value="65">Nota Fiscal de Consumidor</md-option>
            <md-option value="59">SAT</md-option>
          </md-select>
          <md-tooltip md-direction="bottom">Filtrar pelo tipo de Documento</md-tooltip>
        </md-field>
      </div>
      <div class="md-layout-item md-size-15">
        <md-field>
          <md-select
            id="typeFilter"
            v-model="typeFilter"
            name="typeFilter">
            <md-option value="1">Número</md-option>
            <md-option value="2">Chave de acesso</md-option>
            <md-option value="3">Nome do cliente</md-option>
            <md-option value="4">CNPJ/CPF cliente</md-option>
            <md-option value="5">Status</md-option>
          </md-select>
          <md-tooltip md-direction="bottom">Escolha a opção para realizar o filtro</md-tooltip>
        </md-field>
      </div>

      <div
        v-show="typeFilter === '1'"
        class="md-layout-item md-size-30">
        <md-field>
          <label>Número</label>
          <md-input
            v-model="number"
            placeholder="Número do documento"
            @keyup.enter="setItens(4)"/>
        </md-field>
        <md-tooltip md-direction="bottom">Pressione Enter para realizar a busca</md-tooltip>
      </div>

      <div
        v-show="typeFilter === '2'"
        class="md-layout-item md-size-30">
        <md-field>
          <label>Chave de Acesso</label>
          <md-input
            v-model="chaveAcesso"
            placeholder="Chave de Acesso"
            @keyup.enter="setItens(3)"/>
        </md-field>
        <md-tooltip md-direction="bottom">Pressione Enter para realizar a busca</md-tooltip>
      </div>

      <div
        v-show="typeFilter === '3'"
        class="md-layout-item md-size-30">
        <md-field>
          <label>Nome do cliente</label>
          <md-input
            v-model="customerName"
            placeholder="Nome do cliente"
            @keyup.enter="setItens(5)"/>
        </md-field>
        <md-tooltip md-direction="bottom">Pressione Enter para realizar a busca</md-tooltip>
      </div>

      <div
        v-show="typeFilter === '4'"
        class="md-layout-item md-size-30">
        <md-field>
          <label>CNPJ/CPF do cliente</label>
          <md-input
            v-model="customerIdentification"
            placeholder="CNPJ/CPF do cliente"
            @keyup.enter="setItens(6)"/>
        </md-field>
        <md-tooltip md-direction="bottom">Pressione Enter para realizar a busca</md-tooltip>
      </div>

      <div
        v-show="typeFilter === '5'"
        class="md-layout-item md-size-30">
        <md-field>
          <md-select
            id="statusDoc"
            v-model="statusDoc"
            placeholder="Selecione o status"
            name="statusDoc"
            @input="setItens(7)"
          >
            <md-option value="1">Autorizadas</md-option>
            <md-option value="2">Canceladas</md-option>
            <md-option value="3">Inutilizadas</md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <md-table
      v-model="nfes"
      :md-selected-value.sync="selected"
      md-fixed-header
      md-card
      @md-selected="onSelect">

      <div
        v-if="isLoading"
        class="loading-table">
        <Spinner
          name="line-scale-pulse-out-rapid"
          color="#448aff"
          no-fade-in/>
      </div>

      <md-table-toolbar>
        <label class="title-card">Total de documentos: {{ total }}</label>
      </md-table-toolbar>

      <md-table-toolbar
        slot="md-table-alternate-header"
        slot-scope="{ count }"
        class="md-selecao">
        <div class="md-toolbar-section-start">{{ getAlternateLabel(count) }}</div>

        <div class="div-action">
          <md-button
            class="md-icon-button"
            @click="sendMail()">
            <md-icon>email

            </md-icon>
          </md-button>
          <md-tooltip md-direction="bottom">Enviar XML por E-mail</md-tooltip>
        </div>
        <div class="div-action">
          <md-button
            class="md-icon-button"
            @click="getPdfUrl()">
            <md-icon>print
            </md-icon>
          </md-button>
          <md-tooltip md-direction="bottom">Visualizar Documento</md-tooltip>
        </div>
        <div class="div-action">

          <md-button
            class="md-icon-button"
            @click="getXML()">
            <md-icon>cloud_download
            </md-icon>
          </md-button>
          <md-tooltip md-direction="bottom">Baixar XML</md-tooltip>
        </div>
      </md-table-toolbar>

      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
        md-selectable="multiple"
        md-auto-select>
        <md-table-cell
          v-if="item.status === UNUTILIZED"
          md-label="Status">
          <label class="label-grey">Inutilizada</label>
        </md-table-cell>
        <md-table-cell
          v-if="item.status === CANCELED"
          md-label="Status">
          <label class="label-red">Cancelada</label>
        </md-table-cell>
        <md-table-cell
          v-if="item.status === null || item.status === AUTHORIZED"
          md-label="Status">
          <label class="label-green">Autorizada</label>
        </md-table-cell>
        <md-table-cell
          md-label="Número"
          md-numeric>{{ item.number }}</md-table-cell>
        <md-table-cell
          md-label="Modelo"
          md-numeric>{{ item.model }}</md-table-cell>
        <md-table-cell
          v-if="item.type == SALE"
          md-label="Tipo">
          <label class="label-green">Venda</label>
        </md-table-cell>
        <md-table-cell
          v-if="item.type == PURCHASE"
          md-label="Tipo"><label class="label-red">Compra</label>
        </md-table-cell>
        <md-table-cell
          v-if="item.unutilizedXml"
          md-label="Tipo"><label class="label-grey">Nota Inutilizada</label>
        </md-table-cell>
        <md-table-cell
          md-label="R$"
          md-numeric>{{ item.totalValue | currency }}</md-table-cell>
        <md-table-cell md-label="Data/Hora">
          {{ formatDate(item.emission) }}
        </md-table-cell>
        <md-table-cell md-label="Cliente">
          {{ doRemoveString(item.customerName, 10) }}
        </md-table-cell>
        <md-table-cell md-label="CNPJ/CPF">
          {{ item.customerIdentification }}
        </md-table-cell>
      </md-table-row>
      <div
        v-if="total === 0"
        class="sem-total">
        <div class="title-total">
          <label class="title-card">
            Nenhum documento localizado
          </label>
        </div>
      </div>
    </md-table>

    <div class="md-layout">
      <div class="md-layout-item md-size-10">
        <md-field>
          <md-select
            id="registers"
            v-model="registers"
            name="registers"
            placeholder="Registros"
            @input="setRegisterPerPage()">
            <md-option value="15">15</md-option>
            <md-option value="30">30</md-option>
            <md-option value="60">60</md-option>
          </md-select>
          <md-tooltip md-direction="bottom">Registros por página</md-tooltip>
        </md-field>
      </div>
      <div class="md-layout-item md-size-75">
        <Pagination
          v-if="nfes.length > 0"
          :total="total"
          :current_page="page"
          :itens-per-page="itensPerPage"
          :offset="offset"
          :itens-page="itensPage"
          @next="onChangePage"/>
      </div>
    </div>

  </Content>
</template>
<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker'
import swal from 'sweetalert';
import { http, myInvoicesGet, myInvoicesPost } from '../../public/api/backend';
import Content from '../public/Content.vue';
import Pagination from '../../public/pagination/Pagination.vue';
import { filterConst } from '../../public/api/filterConst';
import { docStatus } from '../../public/api/docStatus';

export default {
  name: 'Notas',
  components: {
    Content,
    Pagination,
    DatePicker,
  },
  data() {
    return {
      identification: '',
      nfes: [],
      client: [],
      selected: [],
      total: '',
      page: 1,
      itensPerPage: '',
      offset: 3,
      dateEmissionFrom: null,
      dateEmissionTo: null,
      model: null,
      chaveAcesso: null,
      itensPage: 15,
      typeFilter: '1',
      number: null,
      docAllowed: 1,
      searchFilter: null,
      customerName: null,
      customerIdentification: null,
      statusDoc: null,
      emailAccountant: '',
      ids: [],
      registers: 15,
    };
  },
  computed: {
    AUTHORIZED() {
      return docStatus.AUTHORIZED
    },
    CANCELED() {
      return docStatus.CANCELED
    },
    UNUTILIZED() {
      return docStatus.UNUTILIZED
    },
    SALE() {
      return docStatus.SALE
    },
    PURCHASE() {
      return docStatus.PURCHASE
    },
    isLoading() {
      return this.$store.getters.isLoading
    },

  },
  created() {
    this.getClient()
  },
  mounted() {
    this.$store.commit('SET_LOADING_STATUS', true)
  },
  methods: {

    onSelect(items) {
      this.selected = items
    },

    getAlternateLabel(count) {
      let plural = ''

      if (count > 1) {
        plural = 's'
      }
      return `${count} Documento${plural} selecionado${plural}`
    },

    getXMLAll() {
      swal({
        title: 'Deseja realizar o download do XML?',
        text: 'Aguarde, pois o download será feito automaticamente!',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.close()
            swal.stopLoading()
            return
          }

          const idsCollection = [];
          const zipLenght = 200

          if (this.selected.length > 0) {
            for (let i = 0; i < this.selected.length; i++) {
              idsCollection[i] = this.selected[i].id;
            }
            this.downloadXmlSelected(idsCollection)
            return
          }

          for (let i = 0; i < this.ids.length; i += zipLenght) {
            const xmlPack = this.ids.slice(i, i + zipLenght);
            idsCollection.push(xmlPack);
          }
          this.downloadXmlFilter(idsCollection)
        });
    },

    getXML() {
      swal({
        title: 'Deseja realizar o download do XML?',
        text: 'Aguarde, pois o download será feito automaticamente!',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.close()
            swal.stopLoading()
            return
          }

          const idsCollection = [];

          for (let i = 0; i < this.selected.length; i++) {
            idsCollection[i] = this.selected[i].id;
          }

          this.downloadXmlSelected(idsCollection);
        })
    },

    getPdfUrl() {
      if (this.selected.length === this.docAllowed) {
        swal({
          title: 'Deseja realizar a visualização do documento?',
          text: 'Aguarde, pois será gerado o PDF automaticamente!',
          icon: 'warning',
          buttons: {
            cancel: {
              text: 'Cancelar',
              value: 'cancel',
              visible: true,
              closeModal: true,
            },
            confirm: {
              text: 'OK',
              visible: true,
              closeModal: false
            }
          },
          dangerMode: false,
          closeModal: false,
          closeOnClickOutside: false,
        })
          .then((value) => {
            if (value === 'cancel') {
              swal.close()
              swal.stopLoading()
              return
            }
            let idDoc = '';
            for (let i = 0; i < this.selected.length; i++) {
              idDoc = this.selected[i].id;
            }
            http.post('fiscal.get-storage-print-url', { id: idDoc })
              .then(response => {
                this.$store.commit('SET_LOADING_STATUS', false)
                window.open(response.data.danfeUrl, '_blank');
                swal.stopLoading()
                swal.close()
              })
              .catch(error => {
                this.$toasted.show(error.response.data.error_message, {
                  theme: 'outline',
                  position: 'bottom-right',
                  duration: 5000,
                  type: 'error',
                  icon: 'error_outline'
                });
                swal.stopLoading()
                swal.close()
                this.$store.commit('SET_LOADING_STATUS', false)
              })
          });
        return
      }
      this.$toasted.show('Selecione somente um documento!', {
        theme: 'outline',
        position: 'bottom-right',
        duration: 5000,
        type: 'error',
        icon: 'error_outline'
      });
    },

    sendMail() {
      swal({
        title: 'Deseja realizar o envio dos XMLs por e-mail?',
        text: `O e-mail padrão para envio: ${this.emailAccountant}, caso deseja mandar para outro e-mail, preencha o campo abaixo. `,
        icon: 'warning',
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Informe o e-mail',
          }
        },
        buttons: {
          cancel: {
            text: 'Cancelar',
            visible: true,
            value: 'cancel',
            closeModal: true,
          },
          confirm: {
            text: 'Enviar',
            visible: true,
            closeModal: false,
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.close()
            swal.stopLoading()
            return
          }
          let mailSend = value
          if (value === '') {
            mailSend = this.emailAccountant
          }
          const idsCollection = [];
          for (let i = 0; i < this.selected.length; i++) {
            idsCollection[i] = this.selected[i].id;
          }
          http.post('clipp.send-xml-to-mail', { ids: idsCollection, email: mailSend })
            .then(() => {
              this.$store.commit('SET_LOADING_STATUS', false)
              swal.stopLoading()
              swal.close()
              this.$toasted.show('E-mail enviado com sucesso!', {
                theme: 'outline',
                position: 'bottom-right',
                duration: 5000,
                type: 'success',
                icon: 'check_circle'
              });
            })
            .catch(() => {
              this.$toasted.show('Falha ao enviar e-mail', {
                theme: 'outline',
                position: 'bottom-right',
                duration: 5000,
                type: 'error',
                icon: 'error_outline'
              });
              this.$store.commit('SET_LOADING_STATUS', false)
            })
        });
    },

    getClient() {
      http.post('application.get-client')
        .then(response => {
          this.client = response.data
          this.identification = response.data.identification
          this.emailAccountant = response.data.emailAccountant
          if (this.$route.params.model === 'all') {
            this.setItens(filterConst.FILTERDEFAULT)
            return
          }
          if (this.$route.params.model) {
            this.model = this.$route.params.model
            this.setItens(filterConst.FILTERMODEL)
            return
          }
          this.getNFes()
        })
    },

    getNFes(event) {
      this.$store.commit('SET_LOADING_STATUS', true)
      this.searchFilter = event

      const data = {
        page: this.page,
        maxResults: this.itensPage,
      }
      switch (this.searchFilter) {
        case filterConst.FILTERDATE:
        case filterConst.FILTERMODEL:
          if (this.model) {
            data.model = this.model
          }
          break;
        case filterConst.FILTERDOCKEY:
          this.page = 1
          data.docKey = this.chaveAcesso
          break;
        case filterConst.FILTERNUMBER:
          data.number = this.number
          break;
        case filterConst.FILTERCUSTOMERNAME:
          data.customerName = this.customerName
          break;
        case filterConst.FILTERCUSTOMERDENTIFICATION:
          data.customerIdentification = this.removeCharacters(this.customerIdentification)
          break;
        case filterConst.FILTERSTATUS:
          data.status = this.statusDoc
          break;
        default:
          break;
      }

      if (this.dateEmissionTo != null && this.dateEmissionFrom != null) {
        data.fromEmission = moment(this.dateEmissionFrom).format('YYYY-MM-DD')
        data.toEmission = moment(this.dateEmissionTo).format('YYYY-MM-DD')
      }

      if (this.model) {
        data.model = this.model
      }

      http.post('clipp.get-xml-by-emissor', data).then(response => {
        this.$store.commit('SET_LOADING_STATUS', false)
        this.nfes = response.data.data
        this.total = response.data.total
        this.itensPerPage = response.data.count
        this.ids = response.data.ids
      }).catch(() => {
        this.$toasted.show('Falha ao tentar buscar os dados.', {
          theme: 'outline',
          position: 'bottom-right',
          duration: 5000,
          type: 'error',
          icon: 'error_outline'
        });
        this.$store.commit('SET_LOADING_STATUS', false)
      })
    },

    setItens(event) {
      this.page = 1
      this.nfes = []
      this.selected = []
      this.getNFes(event)
    },

    onChangePage(page) {
      this.nfes = []
      this.selected = []
      this.page = page
      this.getNFes(this.searchFilter)
    },
    setDefault(event) {
      this.$route.params.model = 'all'
      this.chaveAcesso = ''
      this.dateEmissionFrom = null
      this.dateEmissionTo = null
      this.model = null
      this.page = 1
      this.total = ''
      this.itensPage = 15
      this.number = null
      this.customerName = null
      this.customerIdentification = null
      this.typeFilter = '1'
      this.registers = 15
      this.nfes = []
      this.selected = []
      this.getNFes(event)
    },

    setRegisterPerPage() {
      this.searchFilter = 0
      this.page = 1
      this.itensPage = this.registers
      this.nfes = []
      this.selected = []
      this.getNFes()
    },

    async downloadXmlSelected(resultIds) {
      await http.post('clipp.download-xml-files', {
        ids: resultIds
      })
        .then(response => {
          this.$store.commit('SET_LOADING_STATUS', false)
          const link = document.createElement('a')
          link.href = response.data.url
          link.click()
          swal.stopLoading()
          swal.close()
        })
        .catch(error => {
          this.$toasted.show(error.response.data.error_message, {
            theme: 'outline',
            position: 'bottom-right',
            duration: 6000,
            type: 'error',
            icon: 'error_outline'
          });
          swal.stopLoading()
          swal.close()
          this.$store.commit('SET_LOADING_STATUS', false)
        });
    },

    async downloadXmlFilter(resultIds) {
      for (let i = 0; i < resultIds.length; i++) {
        await http.post('clipp.download-xml-files', {
          ids: resultIds[i]
        })
          .then(response => {
            this.$store.commit('SET_LOADING_STATUS', false)
            const link = document.createElement('a')
            link.href = response.data.url
            link.click()

            if (i + 1 === resultIds.length) {
              swal.stopLoading()
              swal.close()
            }
          })
          .catch(() => {
            this.$toasted.show('Não foi possível fazer o download.', {
              theme: 'outline',
              position: 'bottom-right',
              duration: 6000,
              type: 'error',
              icon: 'error_outline'
            });
            swal.stopLoading()
            swal.close()
            this.$store.commit('SET_LOADING_STATUS', false)
          })
      }
    },

    formatDate(value) {
      return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
    },

    doRemoveString(str, size) {
      if (!str) {
        return str;
      }

      if (str.length >= size + 3) {
        return str.substring(0, size).concat('..')
      }
      return str;
    },

    removeCharacters(value) {
      return value.replace(/\^|~|\?|,|\*|\.|-|\/|/g, '');
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/client/notas/Notas.vue